/* Menu sin flechas; en celular el submenu se abre como tarjeta con botones grandes */
(function() {
  var css = [
    '.custom-navigation-bar .dropdown-toggle::after, .custom-navigation-bar .nav-item.dropdown-toggle::after { content: none !important; display: none !important; }',
    '@media screen and (max-width: 768px) {',
    '  .custom-navigation-bar .nav-container { position: static !important; }',
    '  .custom-navigation-bar .dropdown { position: static !important; }',
    '  .custom-navigation-bar .dropdown-menu { position: absolute !important; top: 100% !important; left: 6px !important; right: 6px !important; width: auto !important; min-width: 0 !important; transform: none !important; margin-top: 8px !important; padding: 10px !important; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; border-radius: 14px !important; }',
    '  .custom-navigation-bar .dropdown.active .dropdown-menu { transform: none !important; }',
    '  .custom-navigation-bar .dropdown-item { text-align: center; padding: 14px 6px !important; border-radius: 10px; background: rgba(255,255,255,0.14); border-bottom: none !important; border-left: none !important; font-size: 12px !important; transform: none !important; }',
    '}'
  ].join('\n');
  var style = document.createElement('style');
  style.id = 'dtn-menu-iconos';
  style.textContent = css;
  document.head.appendChild(style);
})();

document.addEventListener('DOMContentLoaded', function() {
  // Logo del encabezado en alta resolucion: el tema lo pide a 90 px; se ofrecen versiones mas grandes
  // (el archivo mide 500 px) para que se vea nitido en pantallas retina. Se muestra a 130 px (76 px en celular).
  document.querySelectorAll('.header-modern .logo-image').forEach(function(img) {
    var src = img.getAttribute('src') || '';
    if (src.indexOf('width=') === -1) { return; }
    var sized = function(n) { return src.replace(/width=\d+/, 'width=' + n); };
    img.setAttribute('srcset', sized(260) + ' 260w, ' + sized(390) + ' 390w, ' + sized(500) + ' 500w');
    img.setAttribute('sizes', '(max-width: 768px) 76px, 130px');
  });

  const navBar = document.getElementById('customNavBar');
  const navPlaceholder = document.getElementById('navPlaceholder');
  if (!navBar || !navPlaceholder) { return; }
  let navBarTop = navBar.offsetTop;
  let ticking = false;

  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(function() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > navBarTop) {
          navBar.classList.add('scrolled');
          navPlaceholder.classList.add('active');
        } else {
          navBar.classList.remove('scrolled');
          navPlaceholder.classList.remove('active');
        }

        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('resize', function() {
    if (!navBar.classList.contains('scrolled')) {
      navBarTop = navBar.offsetTop;
    }
  });

  window.addEventListener('scroll', handleScroll);

  // Dropdown functionality (solo dentro de la barra de navegacion, para no chocar con otros elementos de la pagina)
  const dropdowns = navBar.querySelectorAll('.dropdown');

  dropdowns.forEach(dropdown => {
    const dropdownToggle = dropdown.querySelector('.dropdown-toggle');
    if (!dropdownToggle) { return; }

    dropdownToggle.addEventListener('click', function(e) {
      // En computador (con mouse) el submenu se abre al pasar el mouse y el clic va a la categoria.
      // En pantallas tactiles el primer toque abre el submenu y el segundo va a la categoria.
      const href = dropdownToggle.getAttribute('data-href');
      const canHover = window.matchMedia('(hover: hover)').matches && window.innerWidth > 768;
      if (href && (canHover || dropdown.classList.contains('active'))) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      // Close other dropdowns
      dropdowns.forEach(otherDropdown => {
        if (otherDropdown !== dropdown) {
          otherDropdown.classList.remove('active');
        }
      });

      dropdown.classList.toggle('active');
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('#customNavBar .dropdown')) {
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('active');
      });
    }
  });

  // Close dropdown on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      dropdowns.forEach(dropdown => {
        dropdown.classList.remove('active');
      });
    }
  });

  // Mobile menu functionality
  const mobileMenuToggle = document.getElementById('mobileMenuToggle');
  const navContainer = document.getElementById('navContainer');

  if (mobileMenuToggle && navContainer) {
    mobileMenuToggle.addEventListener('click', function() {
      navContainer.classList.toggle('active');

      if (navContainer.classList.contains('active')) {
        mobileMenuToggle.innerHTML = '✕';
        mobileMenuToggle.style.transform = 'rotate(180deg)';
      } else {
        mobileMenuToggle.innerHTML = '☰';
        mobileMenuToggle.style.transform = 'rotate(0deg)';
      }
    });
  }

  // Close mobile menu when clicking outside
  document.addEventListener('click', function(e) {
    if (navContainer && window.innerWidth <= 768 && navContainer.classList.contains('active')) {
      if (!e.target.closest('.custom-navigation-bar')) {
        navContainer.classList.remove('active');
        if (mobileMenuToggle) {
          mobileMenuToggle.innerHTML = '☰';
          mobileMenuToggle.style.transform = 'rotate(0deg)';
        }
      }
    }
  });

  // Handle resize
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (navContainer && window.innerWidth > 768 && navContainer.classList.contains('active')) {
        navContainer.classList.remove('active');
        if (mobileMenuToggle) {
          mobileMenuToggle.innerHTML = '☰';
          mobileMenuToggle.style.transform = 'rotate(0deg)';
        }
      }

      // Close dropdowns on mobile
      if (window.innerWidth <= 768) {
        dropdowns.forEach(dropdown => {
          dropdown.classList.remove('active');
        });
      }
    }, 250);
  });

  // Handle escape key for mobile menu
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && navContainer && navContainer.classList.contains('active')) {
      navContainer.classList.remove('active');
      if (mobileMenuToggle) {
        mobileMenuToggle.innerHTML = '☰';
        mobileMenuToggle.style.transform = 'rotate(0deg)';
      }
    }
  });
});